(function () {
    'use strict';

    angular
      .module('uwAgenda.global')
      .factory(
        'TranscriptionPaginationService',
        [
          '$rootScope', 
          'TranscriptionService',
          'UserBroadcast',
          'ItemsPerPage',
          'DateService',
          TranscriptionPaginationServiceFn
        ]);

    function TranscriptionPaginationServiceFn(
      $rootScope,
      TranscriptionService,
      UserBroadcast,
      ItemsPerPage,
      DateService) {

        const data = {
            // pagination data
            pagination: {
                currentPage: 1,
                itemsPerPage: 20
            },

            results: [],
            total: 0,
            userId: 0
        };

        return {
            data: data,
            paginate: paginate,
            init: init,
            search: search
        };
        
        function processResults(results) {
            let i = (data.pagination.currentPage - 1) * data.pagination.itemsPerPage;
            return results.map(function (item) {
                const short = item.content.length > 50 ?
                  item.content.substring(0, 50).trimEnd() + '...' :
                  item.content;
                
                return {
                    vmId: ++i,
                    shortContent: short,
                    id: item.id,
                    content: item.content,
                    createDate: item.createDate,
                    isRead: item.isRead,
                };
            });
        }

        function paginate() {
            return TranscriptionService.search(
              data.userId,
              null,
              true,
              false,
              moment(DateService.getDate()).format('YYYY-MM-DD'),
              moment(DateService.next(1)).format('YYYY-MM-DD'),
              data.pagination.currentPage,
              data.pagination.itemsPerPage).then(function (result) {
                data.results = processResults(result.results);
                data.total = result.total;
            });
        }
        
        function search() {
            data.pagination.currentPage = 1;
            return paginate();
        }
        
        function init(userId, itemsPerPage) {
            clean();
            
            data.pagination.itemsPerPage = itemsPerPage || ItemsPerPage.Default.value;
            data.userId = userId;
        }
        
        function clean() {
            data.results = [];
            data.userId = null;
            data.total = 0;
        }

    }
})();